<div class="w-full h-full p-5 min-h-[400px] relative upload-file-component">
  <ngx-file-drop
    [multiple]="false"
    [accept]="acceptString"
    dropZoneLabel="Drop file here"
    (onFileDrop)="dropped($event)"
    style="height: calc(100% - 60px)"
  >
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <div class="empty-table">
        <img height="150" src="assets/images/upload.svg" />

        <div class="empty-table-header">Drop your file here</div>
        <div class="empty-table-body">accepts {{ acceptExtensions }}</div>
        <button
          mat-raised-button
          color="primary"
          type="button"
          *ngIf="state.sourceHistory.length === 0"
          (click)="openFileSelector()"
          class="mb-space-x3"
        >
          Browse Files
        </button>
        <div class="w-full aligner flex-col text-center pt-3" *ngIf="state.selectedFile">
          <b class="fs-09 mb-1 font-semibold">{{ state.selectedFile.name }}</b>
          <b class="fs-08 mb-1 font-normal">{{ state.selectedFile.size | formatSizeUnits }}</b>
        </div>
        <div *ngIf="docsLink"><a href="{{ docsLink }}" target="_blank" rel="noopener noreferrer">Learn more</a></div>
      </div>
    </ng-template>
  </ngx-file-drop>
  <div mat-dialog-actions class="flex my-4 w-full justify-end">
    <button mat-raised-button class="bg-gray-100 mr-4" (click)="cancel()">Cancel</button>
    <button type="submit" [disabled]="!state.selectedFile" color="primary" mat-raised-button (click)="upload()">
      Upload
    </button>
  </div>
</div>
